const PencilLine = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M6.38472 19.7227L7.95699 18.1504H20.4765C20.6914 18.1504 20.8737 18.2286 21.0234 18.3848C21.1796 18.5411 21.2578 18.7266 21.2578 18.9415C21.2578 19.1563 21.1796 19.3386 21.0234 19.4883C20.8737 19.6446 20.6914 19.7227 20.4765 19.7227H6.38472ZM5.40816 18.8243L3.1523 19.6934C3.03512 19.739 2.92769 19.7097 2.83004 19.6055C2.73889 19.5079 2.71611 19.4004 2.76168 19.2833L3.68941 17.1055L14.3535 6.46099L16.0625 8.17974L5.40816 18.8243ZM16.9218 7.3399L15.1933 5.62115L16.1796 4.64459C16.427 4.4037 16.6777 4.27349 16.9316 4.25396C17.192 4.23443 17.4329 4.33534 17.6543 4.5567L17.9863 4.88873C18.2142 5.11659 18.3216 5.35748 18.3086 5.61138C18.2955 5.86529 18.1621 6.1192 17.9082 6.3731L16.9218 7.3399Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default PencilLine;
